
<div class="image-uploader__for-discount">
  <img class="icons" [src]="ICONS.IMAGE" alt="" />
  <p class="label__text">{{label}}</p>
  <div class="add__view-image">
    <a class="__link" (click)="fnOpenReceiptPanel('Add')">{{ "add_more" | translate :param}}</a>
    |
    <div class="link__badge">
      <a class="__link" (click)="fnOpenReceiptPanel('View')">{{ "view_document" | translate :param }}</a>
     @if(field.templateOptions.documentCount>0){<span class="badge-pill">{{field.templateOptions.documentCount}}</span>}
    </div>
  </div>
  @if(formControl.errors && formControl.errors.required && isFormSubmitted && field.templateOptions.documentCount==0){<p class="text-danger">
    {{ "label_Required" | translate: param }}
  </p>}
</div>




<!-- <div class="row margin-top-20 border-bottom padding-bottom-10">
  <div class="col-lg-12 no-padding-right-left">
    <div class="{{alignMentClass}}">
      <button class="padding-15 border border-secondary">
        <span class="d-block">
          <i class="fas fa-image-polaroid f-18" aria-hidden="true">
          </i>
        </span>
      </button>
      <span class="d-block f-12 margin-top-5 text-charcoal-black">{{label}}</span>
      <span class="d-block f-12 margin-top-5 text-charcoal-black">
        <a class="text-logo-blue text-underline" (click)="fnOpenReceiptPanel('Add')">{{ "add_more" | translate :param
          }}</a> |
        <a class="text-logo-blue text-underline" (click)="fnOpenReceiptPanel('View')">{{ "view_document" | translate
          :param }}
          @if(field.templateOptions.documentCount>0){<span class="badge badge-pill badge-danger badge-pill-style">
            {{field.templateOptions.documentCount}}
          </span>}
        </a>
      </span>
    </div>
  </div>
</div> -->
@if(formControl.errors && formControl.errors.required && isFormSubmitted && field.templateOptions.documentCount==0){<div
  class="alert-danger">
  <span> <strong>{{ "label_Required" | translate: param }}</strong></span>
</div>}